import { render, staticRenderFns } from "./reportHistory.vue?vue&type=template&id=b33e6c0e&scoped=true&"
import script from "./reportHistory.vue?vue&type=script&lang=js&"
export * from "./reportHistory.vue?vue&type=script&lang=js&"
import style0 from "./reportHistory.vue?vue&type=style&index=0&id=b33e6c0e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33e6c0e",
  null
  
)

export default component.exports